// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FilesController from "./files_controller"
application.register("files", FilesController)

import ExpandableRowController from "./expandable_row_controller"
application.register("expandable-row", ExpandableRowController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PrinterStationController from "./printer_station_controller"
application.register("printer-station", PrinterStationController)

import PickingStationController from "./picking_station_controller"
application.register("picking-station", PickingStationController)

import PretreatStationController from "./pretreat_station_controller"
application.register("pretreat-station", PretreatStationController)

import CureStationController from "./cure_station_controller"
application.register("cure-station", CureStationController)

import QcStationController from "./qc_station_controller"
application.register("qc-station", QcStationController)

import PackShipStationController from "./pack_ship_station_controller"
application.register("pack-ship-station", PackShipStationController)

import PickListSelectionController from "./pick_list_selection_controller"
application.register("pick-list-selection", PickListSelectionController)

import ProductionDashboardController from "./production_dashboard_controller"
application.register("production-dashboard", ProductionDashboardController)

import DropdownFilterController from "./dropdown_filter_controller"
application.register("dropdown-filter", DropdownFilterController)

import SupplyStationController from "./supply_station_controller"
application.register("supply-station", SupplyStationController)

import ReceivingStationController from "./receiving_station_controller"
application.register("receiving-station", ReceivingStationController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import BatchScannerController from "./batch_scanner_controller"
application.register("batch-scanner", BatchScannerController)

import SkuGeneratorController from "./sku_generator_controller"
application.register("sku-generator", SkuGeneratorController)

import CheckboxSelectController from "./checkbox_select_controller"
application.register("checkbox-select", CheckboxSelectController)
